"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveUpdateQuotasRowPipeline = exports.updateQuotasRowPipeline = exports.UpdateQuotasRowPipelineActionTypes = exports.receiveDeleteQuotaRows = exports.deleteQuotaRows = exports.DeleteQuotaRowsActionTypes = exports.receiveAddQuotaRows = exports.addQuotaRows = exports.AddQuotaRowsActionTypes = exports.receiveDeleteQuotas = exports.deleteQuotas = exports.DeleteQuotasActionTypes = exports.receiveSaveQuotas = exports.saveQuotas = exports.SaveQuotasActionTypes = exports.receiveGetQuotas = exports.getQuotas = exports.GetQuotasActionTypes = exports.QuotaActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _actions = require("settings-ui-sdk/utils/actions");

var QuotaActionTypes = (0, _namespacedKeyMirror.default)({
  GET_QUOTAS: null,
  SAVE_QUOTAS: null,
  DELETE_QUOTAS: null,
  ADD_QUOTA_ROWS: null,
  DELETE_QUOTA_ROWS: null,
  UPDATE_QUOTA_ROW_PIPELINE: null
}, 'quotas');
exports.QuotaActionTypes = QuotaActionTypes;
var GetQuotasActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.GET_QUOTAS);
exports.GetQuotasActionTypes = GetQuotasActionTypes;
var getQuotas = (0, _fluxActions.createAction)(QuotaActionTypes.GET_QUOTAS, _identity.default);
exports.getQuotas = getQuotas;
var receiveGetQuotas = (0, _actions.createRequestActions)(GetQuotasActionTypes);
exports.receiveGetQuotas = receiveGetQuotas;
var SaveQuotasActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.SAVE_QUOTAS);
exports.SaveQuotasActionTypes = SaveQuotasActionTypes;
var saveQuotas = (0, _fluxActions.createAction)(QuotaActionTypes.SAVE_QUOTAS, _identity.default);
exports.saveQuotas = saveQuotas;
var receiveSaveQuotas = (0, _actions.createRequestActions)(SaveQuotasActionTypes);
exports.receiveSaveQuotas = receiveSaveQuotas;
var DeleteQuotasActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.DELETE_QUOTAS);
exports.DeleteQuotasActionTypes = DeleteQuotasActionTypes;
var deleteQuotas = (0, _fluxActions.createAction)(QuotaActionTypes.DELETE_QUOTAS, _identity.default);
exports.deleteQuotas = deleteQuotas;
var receiveDeleteQuotas = (0, _actions.createRequestActions)(DeleteQuotasActionTypes);
exports.receiveDeleteQuotas = receiveDeleteQuotas;
var AddQuotaRowsActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.ADD_QUOTA_ROWS);
exports.AddQuotaRowsActionTypes = AddQuotaRowsActionTypes;
var addQuotaRows = (0, _fluxActions.createAction)(QuotaActionTypes.ADD_QUOTA_ROWS, _identity.default);
exports.addQuotaRows = addQuotaRows;
var receiveAddQuotaRows = (0, _actions.createRequestActions)(AddQuotaRowsActionTypes);
exports.receiveAddQuotaRows = receiveAddQuotaRows;
var DeleteQuotaRowsActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.DELETE_QUOTA_ROWS);
exports.DeleteQuotaRowsActionTypes = DeleteQuotaRowsActionTypes;
var deleteQuotaRows = (0, _fluxActions.createAction)(QuotaActionTypes.DELETE_QUOTA_ROWS, _identity.default);
exports.deleteQuotaRows = deleteQuotaRows;
var receiveDeleteQuotaRows = (0, _actions.createRequestActions)(DeleteQuotaRowsActionTypes);
exports.receiveDeleteQuotaRows = receiveDeleteQuotaRows;
var UpdateQuotasRowPipelineActionTypes = (0, _actions.createRequestTypes)(QuotaActionTypes.UPDATE_QUOTA_ROW_PIPELINE);
exports.UpdateQuotasRowPipelineActionTypes = UpdateQuotasRowPipelineActionTypes;
var updateQuotasRowPipeline = (0, _fluxActions.createAction)(QuotaActionTypes.UPDATE_QUOTA_ROW_PIPELINE, _identity.default);
exports.updateQuotasRowPipeline = updateQuotasRowPipeline;
var receiveUpdateQuotasRowPipeline = (0, _actions.createRequestActions)(UpdateQuotasRowPipelineActionTypes);
exports.receiveUpdateQuotasRowPipeline = receiveUpdateQuotasRowPipeline;